<template>
<div class="loginbig">
     <div class="enform"
         v-loading="loading"
            element-loading-text="正在登录中..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
     >
            <div class="enform-tit">
               账户登录
            </div>
            <div class="enform-ewm"
        
            >
                 <el-tooltip class="item" effect="dark" content="暂未开放" placement="top-start">
                <img src="../../../assets/images/enewm.png" alt="">
                  </el-tooltip>
            </div>
            <div class="enform-ipt">
                      	<el-form label-position="right" label-width="0px" :model="formLabelAlign" ref="form" :rules="rules">
						<el-form-item  prop="username">
							<el-input  prefix-icon="icon-al-user-fill" placeholder="用户名" v-model="formLabelAlign.username" clearable></el-input>
						</el-form-item>
						<el-form-item  prop="password">
							<el-input prefix-icon="icon-al-lock-fill" placeholder="请输入密码" v-model="formLabelAlign.password"  show-password clearable></el-input>
						</el-form-item>
					</el-form>
            </div>
            <div class="enform-forget">
                忘记密码？
                </div>
            <div class="enform-btn">
                 <img src="../../../assets/images/enbtn.png" alt=""  @click="login">
            </div>
        </div>
   </div>
</div>
</template>
<script>
import { login } from "@/api/auth/login"
import  Format from "../../../utils/auth.js"  
import LocaStorage from "../../../utils/localstorage.js"
import debounce from '../../../utils/debounce.js' //防抖
    export default {
        name: "login",
        components: {
        },
         data: () => {
            return {
              loading:false,
              formLabelAlign:{
               username:'',
               password:''
              },
               rules:{
                 username:[
                     {
                        validator: Format.FormValidate.Form().Account,   //validator： 自定义验证规则
                        trigger: "blur",
                        message:'请正确输入账户名',
                        }
                 ],
                 password: [{ required: true, message: '请输入密码', trigger: 'blur' },
                 { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
                 ],
               }
            }
        },
        created() {
        },
        mounted() {},
        computed: {
        },

        watch: {},
        methods: {
            // 登录
            login(){
                let that = this
                this.$refs['form'].validate((valid) => {
                  if(valid){
                    let params = {
				 	          username:this.formLabelAlign.username,
                    password:this.formLabelAlign.password
				   	       };
             localStorage.removeItem('token')
					localStorage.removeItem('userinfo')
          this.loading = true
          // 防抖
             debounce(() => {
              	 login(params,1).then((res) => {
                  this.loading = false
				      if(res) {
                 
				  		this.$message({
				 		message: '登录成功',
				 		type: 'success'
				 		});
              LocaStorage.setAge().set('token',res.token_type + ' ' + res.access_token)
              LocaStorage.setAge().set('userinfo',res.user_info)
              if(!that.$route.query.redirectUrl){
                 setTimeout(() => {
                that.$router.push("/fzmanage/Admin")
                }, 100);
              }else{
                setTimeout(() => {
					    that.$router.replace({
                name:that.$route.query.redirectUrl,
                query:{
                            id:that.$route.query.id
                   }
                 })
					      },100);
              }
				       
				      }else{
						that.$message.error(res.message); 
					  }
				    }).catch(err => {
              this.loading = false
				    });
            }, 500)

					}
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
.loginbig{
     width: 100%;
    height: 100vh;
    background: url('~@/assets/images/enbg.jpg') no-repeat 0 0;
    background-size: 100% 100%;
    overflow: hidden;
    position: relative;
       .enform{
        width: 394px;
        height: 468px;
        background: url('~@/assets/images/enbg1.png') no-repeat 0 0;
        background-size: 100% 100%;
        position: absolute;
        top: 50%;
        margin-top: -234px;
        right: 18%;
      .enform-tit{
        padding: 30px 40px;
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: 300;
        color: #4B4B4B;
        line-height: 38px;
      }
      .enform-ewm{
        position: absolute;
        top: 40px;
        right: 40px;
        width: 38px;
        cursor: pointer;
      }
      .enform-ipt{
        padding: 30px 40px;
        margin-top: 30px;
        padding-bottom: 0px;
      }
      .enform-forget{
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #4A93F6;
        line-height: 38px;
        text-align: right;
        padding-right: 40px;
      }
      .enform-btn{
        text-align: center;
        margin-top: 30px;
        img{
            width: 176px;
            cursor: pointer;
        }
      }
    }
}
@media (max-width: 640px){
    .loginbig{
        background-size: cover;
        background-position: 100%;
        .enform{
            width: 320px;
            margin: 0 auto;
            position: absolute;
            top: 50%;
            margin-top: -200px;
            right: 50%;
            margin-right: -160px;
            height: 400px;
            .enform-ipt{
                margin-top: 0;
            }
        }
    }
}
::v-deep{
    .el-input__inner{
        border: none;
        border-bottom: 1px solid #BCBCBC;
        border-radius: 0;
    }
    .el-input{
        margin-top: 40px;
    }
    .el-input:first-child{
        margin-top: 0;
    }
}
</style>